import { deleteAccount, } from '../types'
import HttpService from '../../services/HttpService'

export const deleteAccountAction = () => {
  return async dispatch => {
    
    dispatch({ type: deleteAccount.DELETE_ACCOUNT_ERROR, })

    let storage
    try {
      storage = JSON.parse(localStorage.getItem("user-token"))
    } catch (err) {
      return dispatch({ 
        type: deleteAccount.DELETE_ACCOUNT_ERROR, 
        payload: message,
      })
    }
    const http = new HttpService()
    await http.deleteData(
      '/users/'+storage.data.user.id,
      "user-token",
    )
      .then(res => {
        dispatch({
          type: deleteAccount.DELETE_ACCOUNT_SUCCESS,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: deleteAccount.DELETE_ACCOUNT_ERROR, 
          payload: message,
        })
      })
  }
}